package navigation.settings.paymentparameter

import navigation.settings.paymentparameter.addeditpaymentparameter.AddEditPaymentParameterScreenModel
import navigation.settings.paymentparameter.paymentparameter.PaymentParameterScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val paymentParameterUiModule
    get() =
        module {
            factoryOf(::PaymentParameterScreenModel)
            factoryOf(::AddEditPaymentParameterScreenModel)
        }